<template>
  <div ref="host" class="map__ct">
    <NMap :boundsModel="boundsModel" @mousemove.native="mouseMoveHandler" @mouseout.native="mouseOutHandler" class="h-100">
      <NTilesLayer />
      <template v-for="layer of layers">
        <NTilesLayer :key="layer.name" v-if="layer && !layer.styleURL" :layer="layer"/>
        <NWMSLayer :key="layer.name" v-if="layer && layer.styleURL" :srs="srs" :layer="layer" :loader="loader" :info="layer && (layer.name == 'RasterCrops')? info: null"/>
      </template>
    </NMap>
    <transition name="fade">
      <div v-if="loader.numLoading" class="lottie">
        <Lottie></Lottie>
      </div>
    </transition>
    <div class="map-actions">
      <div class="zoom-action" @click="zoomIn">
        <img src="../../assets/img/plus.svg" alt />
      </div>
      <div class="zoom-action" @click="zoomOut">
        <img src="../../assets/img/minus.svg" alt />
      </div>
    </div>
    <div v-if="info" class="position-absolute chart-tooltip" :style="{ left: (info.x + 10) + 'px', top: info.y + 'px' }">
      {{infoText}}
    </div>
  </div>
</template>


<script>
import Lottie from "@/components/shared/Lottie.vue";
import {
  CenterScale,
  FocusModel,
  Loader,
  SRS,
  Timer,
  WMSInfo,
  defaultFocusModel,
  windowBoundsModel
} from "vue-niney";
import NMap from "vue-niney/NMap.vue";
import NTilesLayer from "vue-niney/NTilesLayer.vue";
import NWMSLayer from "vue-niney/NWMSLayer.vue";
export default {
  name: "Map",
  components: {
    NMap,
    NTilesLayer,
    NWMSLayer,
    Lottie
  },
  props: {
    layers: { type: Array }
  },
  data() {
    const srs = new SRS();
    srs.minX = -20010000;
    srs.minY = -7540851.04344194;
    srs.maxX = 20010000;
    srs.maxY = 17903109.435964;
    
    return {
      boundsModel: windowBoundsModel,
      srs: srs,
      loader: new Loader(),
      info: null
    };
  },
  created: function() {
    this.timer = new Timer(650, 1);
  },
  methods: {
    mouseMoveHandler(mouseEvent) {
      this.timer.reset();
      this.timer.timerHandler = () => {
        var clientRect = this.$refs.host.getBoundingClientRect();
        var mouseX = mouseEvent.clientX - clientRect.left;
        var mouseY = mouseEvent.clientY - clientRect.top;
        this.info = new WMSInfo(mouseX, mouseY);
      };
      this.timer.start();
      this.info = null;
    },
    mouseOutHandler(mouseEvent) {
      this.timer.stop();
      this.info = null;
    },
    zoomIn: function() {
      var cs = defaultFocusModel.animationCenterScale;
      defaultFocusModel.setCenterScale(
        new CenterScale(cs.centerX, cs.centerY, cs.scale / 2),
        FocusModel.ALWAYS_NEAREST
      );
    },
    zoomOut: function() {
      var cs = defaultFocusModel.animationCenterScale;
      defaultFocusModel.setCenterScale(
        new CenterScale(cs.centerX, cs.centerY, cs.scale * 2),
        FocusModel.ALWAYS_NEAREST
      );
    }
  },
  computed: {
    infoText() {
      if (this.info.value == null) {
        return "Loading...";
      } else if (this.info.value == "0.0") {
        return "No " + this.layers[0].classification.title.toLowerCase();
      }
      return this.layers[0].classification.title + ": " + this.info.value + " mm/yr";
    }
  }
};
</script>

<style lang="scss" scoped>
.map {
  &__ct {
    height: calc(100vh - 60px);
  }
}
.h-100 {
  height: 100%;
}
.map-actions {
  position: absolute;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  img {
    width: 30px;
  }
}
.zoom-action {
  margin-bottom: 10px;
  cursor: pointer;
}
</style>

